module.exports = __webpack_public_path__ + "img/fuwu.bfb6091e.png";